import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { RoutesManagerService } from './services/routes-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {

  private subscription: Subscription;

  constructor(private router: Router, private routesManager: RoutesManagerService) {
    this.subscription = this.onRefreshRedirectToIntroduction();
    this.routesManager.setLocalRouteValue('introduccion');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onRefreshRedirectToIntroduction(): Subscription {
    return this.router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
      .subscribe(event => {
        if (
          event.id === 1 &&
          event.url === event.urlAfterRedirects
        ) {
          this.routesManager.setLocalRouteValue('introduccion');
          this.router.navigate(['introduccion']);
        }
      });
  }


}
